// src/components/utils/ErrorBoundary.jsx
import React from 'react';
import ErrorMessageUI from './ErrorMessageUI';
import { errorDev } from '../../lib/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    errorDev('Uncaught error caught by Error Boundary:', error, errorInfo);
    this.setState({ errorInfo: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // Renderuj komponent UI błędu, przekazując mu szczegóły błędu
      return (
        <ErrorMessageUI
          error={this.state.error}
          errorInfo={this.state.errorInfo}
        />
      );
    }

    // Jeśli nie ma błędu, renderuj dzieci
    return this.props.children;
  }
}

export default ErrorBoundary;
